/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Heading_Cant_GradeInputs */



/**
* | output |
* | --- |
* | "Something broke (no, you can't grade it)" |
*
* @param {Error_Heading_Cant_GradeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_heading_cant_grade = /** @type {((inputs?: Error_Heading_Cant_GradeInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Heading_Cant_GradeInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Etwas ist kaputt (nein, das kannst du nicht graden lassen)")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quelque chose a cassé (non, ça ne se fait pas grader)")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("出了点问题（不，这个不能拿去评级）")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("有東西壞掉了（不，這沒辦法送鑑定）")
	if (locale === "ko") return /** @type {LocalizedString} */ ("무언가 망가졌습니다(등급 감정은 안 됩니다)")
	return /** @type {LocalizedString} */ ("Something broke (no, you can't grade it)")
});